<div class="p-grid p-nogutter p-align-center report-holder">
  <div class="p-col shrink m-r-20">
    <div [ngSwitch]="!!fileId">
      <div *ngSwitchCase="true">
        <a *ngIf="fileId"
           (click)="getSummaryNote(fileId)">
          <i class="fa fa-download fa-lg text-success"></i>
        </a>
      </div>
      <div *ngSwitchDefault>
        <i class="fa fa-times-circle fa-lg text-danger"></i>
      </div>
    </div>
  </div>
  <div class="p-col">
    <div class="m-b-5">{{ title }}</div>
    <div [ngSwitch]="!!date">
      <div *ngSwitchCase="true" class="text-danger">
        <div *ngIf="isOlderReport && isOlderThanYear" class="inline-block">
          <a class="upload-button" [routerLink]="['/organizations', organizationId, 'modify', 'reporting']">
            {{ 'DATA_PORTAL.UPLOAD' | translate }}
          </a>
        </div>
        <span class="m-l-5 m-b-5" *ngIf="isOlderReport && isOlderThanYear">
          <i class="fa fa-flag m-r-5"></i> {{ notUploadedLabel }}
        </span>
        <span class="subtext" *ngIf="!isOlderThanYear">
          {{ ('DATA_PORTAL.ANNUAL_REPORTING.UPLOADED_ON' | translate) + ' ' + (date | date) }}
        </span>
      </div>
      <div *ngSwitchDefault class="text-danger">
        <div class="m-r-10 inline-block">
          <a class="upload-button" [routerLink]="['/organizations', organizationId, 'modify', 'reporting']">
            {{ 'DATA_PORTAL.UPLOAD' | translate }}
          </a>
        </div>
        <span class="m-b-5 inline-block">
          <i class="fa fa-flag m-r-5 "> </i>{{ notUploadedLabel }}
        </span>
      </div>
    </div>
  </div>
</div>
